// lista kategorii

import React, { FC, useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';
import { PlusCircle, DashCircle, ExclamationCircle, PlusSquare, DashSquare } from 'react-bootstrap-icons';
import { Grid } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import { useGetProductsCategories } from 'api';
import { ICategoryListItem, IProductsCategoriesRequest, IProductsRequest } from 'api/types';
import { Loader, Link } from 'components/controls';
import styles from 'theme/pages/Products/components/Categories/Categories.module.scss';

// typ danych wejściowych
interface Props {
  columnsCount?: number;
  chosenCategoryId?: number;
  searchKeyword?: string;
  productsQueryParams: IProductsRequest;
}
const Categories: FC<Props> = ({
  columnsCount = 1,
  chosenCategoryId,
  productsQueryParams
}) => {
  // Lista ID kategorii, które użytkownik chce zwinąć, nawet jeśli mają wybraną podkategorię
  const [collapsedCategoryIds, setCollapsedCategoryIds] = useState<number[]>([]);

  // Nadpisujemy tylko funkcję renderCategoryTree - zmieniamy tylko ikony

  // parametry zapytania do api
  const [categoriesQuery, setCategoriesQuery] = useState<IProductsCategoriesRequest>({
    ...productsQueryParams,
    page: 1,
    limit: 999
  });
  const {
    t
  } = useTranslation();

  // lista ID'ków rozwiniętych kategorii
  const [expandedCategoryIds, setExpandedCategoryIds] = useState<number[]>([]);

  // pobranie listy kategorii
  const {
    data: categoriesData
  } = useGetProductsCategories(categoriesQuery, {
    keepPreviousData: true
  });

  // aktualizacja parametrów zapytania do api przy zmianie parametrów zapytaqnia o produkty
  useEffect(() => {
    if (chosenCategoryId) {
      if (!expandedCategoryIds.includes(chosenCategoryId)) {
        setExpandedCategoryIds(prev => [...prev, chosenCategoryId]);
      }
    }
    setCategoriesQuery({
      ...productsQueryParams,
      page: 1,
      limit: 999
    });
  }, [productsQueryParams]);

  // funkcja renderująca drzewo kategorii
  const renderCategoryTree = category => {
    const renderTree = (categories = [], level = 0) => categories.map(category => {
      // Sprawdzamy, czy kategoria ma wybraną podkategorię
      const hasChosenSubcategory = category.subcategories.some(item => item.id === chosenCategoryId);
      // Kategoria jest rozwinięta, jeśli:
      // 1. Jest w expandedCategoryIds LUB
      // 2. Ma wybraną podkategorię I nie jest w collapsedCategoryIds
      const isExpanded = expandedCategoryIds.includes(category.id) || hasChosenSubcategory && !collapsedCategoryIds.includes(category.id);
      return <div key={category.id} className={classnames(styles.category, {
        [styles.main]: level === 0
      })}>
            {category.subcategories_total_count > 0 && <>
                {isExpanded ? <DashSquare // Zmienione z DashCircle na DashSquare
          className={styles.expandedIcon} onClick={() => {
            // Usuwamy kategorię z expandedCategoryIds
            setExpandedCategoryIds(prevState => prevState.filter(categoryId => categoryId !== category.id));
            // Jeśli kategoria ma wybraną podkategorię, dodajemy ją do collapsedCategoryIds
            if (hasChosenSubcategory) {
              setCollapsedCategoryIds(prevState => [...prevState, category.id]);
            }
          }} /> : <PlusSquare // Zmienione z PlusCircle na PlusSquare
          onClick={() => {
            // Dodajemy kategorię do expandedCategoryIds
            setExpandedCategoryIds(prevState => [...prevState, category.id]);
            // Usuwamy kategorię z collapsedCategoryIds, jeśli tam jest
            setCollapsedCategoryIds(prevState => prevState.filter(categoryId => categoryId !== category.id));
          }} />}
              </>}
            <Link to={`/${category.url_link}`} className={classnames({
          [styles.chosen]: category.id === chosenCategoryId
        })}>
              {category.name} <span className={styles.counter}>({category.products_count})</span>
            </Link>

            {category.subcategories_total_count > 0 && isExpanded && renderTree(category.subcategories, level + 1)}
          </div>;
    });
    return renderTree([category]);
  };
  return <div className={classnames(styles.componentWrapper, 'StylePath-Pages-Products-components-Categories')}>
      {!categoriesData && <Loader />}
      <Grid container>
        {categoriesData?.items.length ? categoriesData?.items.map(category => <Grid item key={category.id} sm={Math.floor(12 / columnsCount)}>
              {renderCategoryTree(category)}
            </Grid>) : <div className={styles.info}>
            <ExclamationCircle />
            <span>
              <ReactMarkdown disallowedElements={['p']} unwrapDisallowed>
                {t('PRODUCTS_SIDEBAR_NO_CATEGORIES_INFO')}
              </ReactMarkdown>
            </span>
          </div>}
      </Grid>
    </div>;
};
export default Categories;